export const MAP_INTEGRATIONS_ENUM = {
  BING: "bing",
  GOOGLE: "google",
  APPLE: "apple",
  FACEBOOK: "facebook"
};
